module.exports = __webpack_public_path__ + "img/92.425769bb.png";